













































































import { Component, Vue, Watch } from 'vue-property-decorator';

import colors from 'vuetify/lib/util/colors';

import { StepsKeys } from '@/plugins/podolib/services/analysis';
import { AnalysisType } from '@/components/analysis/steps/type/AnalysisStepType';
import moment from 'moment';

@Component
export default class AnalysisStepAnalysisTimer extends Vue {
  $refs!: {
    progress: HTMLCanvasElement;
  };

  /**
   * Helper for giving ability to use types and enums in DOM
   */
  tsdom = {
    Type: AnalysisType,
  };

  properties = {
    width: 280,
    height: 280,
    radius: 120,
    markerRadius: 14,
    padding: 20,
    angles: {
      min: -130,
      max: 130,
    },
  };

  ctx: CanvasRenderingContext2D = null!;
  indeterminate = {
    side: 1,
    value: 0,
  };
  play = false;
  timer = null;

  /**
   * Manifest entry of "type" step
   */
  get stepType() {
    return this.$pdc.analysis!.getManifestEntry(StepsKeys.Type);
  }

  /**
   * Manifest entry of "analysis" step
   */
  get stepAnalysis() {
    return this.$pdc.analysis!.getManifestEntry(StepsKeys.Analysis);
  }

  /**
   * Get 'command' entity
   */
  get command() {
    return this.$pdc.analysis!.entityCommand;
  }

  /**
   * Get progress value of "getting data" step
   */
  get progressValue() {
    return this.command?.data.progress ?? '--';
  }

  @Watch('stepAnalysis', { deep: true })
  setStatus() {
    if (
      (this.stepAnalysis.flags.analysis.isPending ||
        this.stepAnalysis.flags.analysis.isStarted ||
        this.stepAnalysis.flags.analysis.isGettingData) &&
      !this.stepAnalysis.error &&
      !this.stepAnalysis.warn
    ) {
      if (!this.play) {
        this.play = true;

        this.draw();
      }
    } else {
      this.play = false;
      this.timer = null;

      this.indeterminate = {
        side: 1,
        value: 0,
      };
    }
  }

  start() {
    this.$emit('start');
  }

  drawSpline() {
    this.ctx.beginPath();
    this.ctx.arc(
      this.properties.radius + this.properties.padding,
      this.properties.radius + this.properties.padding,
      this.properties.radius,
      ((this.properties.angles.min - 90) * Math.PI) / 180,
      ((this.properties.angles.max - 90) * Math.PI) / 180,
    );
    this.ctx.strokeStyle = this.$vuetify.theme.themes.light.secondary as string;
    this.ctx.lineWidth = 10;
    this.ctx.lineCap = 'round';
    this.ctx.stroke();
  }

  drawIndeterminate(angle: number) {
    this.ctx.save();

    this.ctx.translate(this.properties.width / 2, this.properties.height / 2);
    this.ctx.rotate(((angle + 90) * Math.PI) / 180);

    this.ctx.beginPath();
    this.ctx.arc(
      0,
      0,
      this.properties.radius,
      ((this.properties.angles.min / 4 - 180) * Math.PI) / 180,
      ((this.properties.angles.max / 4 - 180) * Math.PI) / 180,
    );
    this.ctx.strokeStyle = this.$vuetify.theme.themes.light.accent as string;
    this.ctx.lineWidth = 10;
    this.ctx.lineCap = 'round';
    this.ctx.stroke();

    this.ctx.restore();
  }

  drawProgress(progress: number, reverse = false) {
    this.ctx.beginPath();
    this.ctx.arc(
      this.properties.radius + this.properties.padding,
      this.properties.radius + this.properties.padding,
      this.properties.radius,
      ((this.properties.angles.min - 90) * Math.PI) / 180,
      ((progress - 90) * Math.PI) / 180,
    );

    if (reverse) {
      this.ctx.strokeStyle = colors.grey.lighten2 as string;
    } else if (progress >= this.properties.angles.max) {
      this.ctx.strokeStyle = this.$vuetify.theme.themes.light.success as string;
    } else {
      this.ctx.strokeStyle = this.$vuetify.theme.themes.light.accent as string;
    }

    this.ctx.lineWidth = 10;
    this.ctx.lineCap = 'round';
    this.ctx.stroke();
  }

  drawMarker(progress: number) {
    this.ctx.save();

    this.ctx.translate(this.properties.width / 2, this.properties.height / 2);
    this.ctx.rotate(((progress + 90) * Math.PI) / 180);

    this.ctx.beginPath();
    this.ctx.arc(-this.properties.radius, 0, this.properties.markerRadius, 0, Math.PI * 2);

    if (progress >= this.properties.angles.max) {
      this.ctx.fillStyle = this.$vuetify.theme.themes.light.success as string;
    } else {
      this.ctx.fillStyle = this.$vuetify.theme.themes.light.accent as string;
    }

    this.ctx.fill();

    this.ctx.beginPath();
    this.ctx.arc(-this.properties.radius, 0, this.properties.markerRadius / 2, 0, Math.PI * 2);
    this.ctx.fillStyle = 'white';
    this.ctx.fill();

    this.ctx.restore();
  }

  clear() {
    this.ctx.clearRect(0, 0, this.properties.width, this.properties.height);
  }

  cubic(t: number) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }

  draw() {
    this.clear();

    this.drawSpline();

    if (!this.play) return;

    // Pending
    if (this.stepAnalysis.flags.analysis.isPending) {
      //
      const x1 = this.properties.angles.min + 32;
      const x2 = this.properties.angles.max - 32;
      const y1 = 0;
      const y2 = 1;

      const value = this.cubic(((this.indeterminate.value - x1) * (y2 - y1)) / (x2 - x1) + y1);
      const tango = parseFloat((((value - y1) * (x2 - x1)) / (y2 - y1) + x1).toFixed(2));

      this.drawIndeterminate(tango);

      if (this.indeterminate.side === 1) {
        if (this.indeterminate.value >= this.properties.angles.max - this.properties.angles.max / 4) {
          this.indeterminate.side = -1;
        } else {
          this.indeterminate.value += 1;
        }
      } else {
        if (this.indeterminate.value <= this.properties.angles.min - this.properties.angles.min / 4) {
          this.indeterminate.side = 1;
        } else {
          this.indeterminate.value -= 1;
        }
      }
    }
    // Analysis
    else if (this.command && this.stepAnalysis.flags.analysis.isStarted && this.stepAnalysis.timer.startDate) {
      const diff = this.stepAnalysis.timer.endDate.diff(this.stepAnalysis.timer.startDate);
      // const value = diff - this.stepAnalysis.timer.endDate.diff(this.$moment());
      // const value = this.stepAnalysis.timer.current;
      // Not use current because we need a faster refresh rate

      let __current = this.$moment();

      if (!this.stepAnalysis.flags.analysis.isInternal) {
        __current = __current.add(this.$pdc.commons!.timeDrift, 'milliseconds');
      }

      const _current = __current.diff(this.stepAnalysis.timer.startDate);

      const x1 = 0;
      const x2 = diff;
      const y1 = this.properties.angles.min;
      const y2 = this.properties.angles.max;

      const angle = parseFloat((((_current - x1) * (y2 - y1)) / (x2 - x1) + y1).toFixed(2));

      if (angle <= this.properties.angles.min) {
        const _x1 = 0;
        const _x2 = this.stepAnalysis.delay;

        const _angle = parseFloat((((_current - _x1) * (y2 - y1)) / (_x2 - _x1) + y1).toFixed(2));

        this.drawProgress(this.properties.angles.min + (this.properties.angles.min - _angle), true);
      } else if (angle >= this.properties.angles.max) {
        this.drawProgress(this.properties.angles.max);
        this.drawMarker(this.properties.angles.max);
      } else {
        this.drawProgress(angle);
        this.drawMarker(angle);
      }
    }
    // Getting data
    else if (this.stepAnalysis.flags.analysis.isGettingData) {
      const x1 = 0;
      const x2 = 100;
      const y1 = this.properties.angles.min;
      const y2 = this.properties.angles.max;

      const angle = parseFloat((((this.command!.data.progress! - x1) * (y2 - y1)) / (x2 - x1) + y1).toFixed(2));

      if (angle <= this.properties.angles.max) {
        this.drawProgress(angle);
      } else {
        this.drawProgress(this.properties.angles.max);
      }
    }

    // requestAnimationFrame();
    setTimeout(() => {
      this.draw();
    }, 5);
  }

  mounted() {
    this.$refs.progress.width = this.properties.width;
    this.$refs.progress.height = this.properties.height;

    this.ctx = this.$refs.progress.getContext('2d')!;

    this.drawSpline();

    this.setStatus();
  }
}
